"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownService = exports.unknownServiceSerdesInterceptor = void 0;
const ThrottlingException_1 = require("@amzn/coral_com-amazon-coral-availability/ThrottlingException");
const BackOffException_1 = require("@amzn/coral_com-amazon-coral-availability/BackOffException");
const InvalidCodigoMessageException_1 = require("@amzn/coral_com-amazon-coral-service-bsf/InvalidCodigoMessageException");
const HttpFailureException_1 = require("@amzn/coral_com-amazon-coral-client/HttpFailureException");
const HttpTimeoutException_1 = require("@amzn/coral_com-amazon-coral-client/HttpTimeoutException");
const ClientUnavailableException_1 = require("@amzn/coral_com-amazon-coral-client/ClientUnavailableException");
const HttpConnectionTimeoutException_1 = require("@amzn/coral_com-amazon-coral-client/HttpConnectionTimeoutException");
const InvalidParameterCombinationException_1 = require("./InvalidParameterCombinationException");
const UnknownOperationException_1 = require("./UnknownOperationException");
const RequestEntityTooLargeException_1 = require("./RequestEntityTooLargeException");
const ExpiredTokenException_1 = require("./ExpiredTokenException");
const InternalFailure_1 = require("./InternalFailure");
const UnrecognizedClientException_1 = require("./UnrecognizedClientException");
const TimeoutException_1 = require("./TimeoutException");
const MalformedHttpRequestException_1 = require("./MalformedHttpRequestException");
const TransmutationException_1 = require("./TransmutationException");
const InvalidQueryStringException_1 = require("./InvalidQueryStringException");
const DelegationException_1 = require("./DelegationException");
const NotAuthorizedException_1 = require("./NotAuthorizedException");
const RequestAbortedException_1 = require("./RequestAbortedException");
const MissingAuthenticationTokenException_1 = require("./MissingAuthenticationTokenException");
const InvalidSignatureException_1 = require("./InvalidSignatureException");
const InvalidAwsQueryStringException_1 = require("./InvalidAwsQueryStringException");
const MissingRequiredParameterException_1 = require("./MissingRequiredParameterException");
const AccessDeniedException_1 = require("./AccessDeniedException");
const IncompleteSignatureException_1 = require("./IncompleteSignatureException");
const MissingActionException_1 = require("./MissingActionException");
const InvalidQueryParameterException_1 = require("./InvalidQueryParameterException");
const InvalidParameterValueException_1 = require("./InvalidParameterValueException");
const ServiceUnavailableException_1 = require("./ServiceUnavailableException");
const SerializationException_1 = require("./SerializationException");
const RequestTimeoutException_1 = require("./RequestTimeoutException");
const UnsupportedMediaTypeException_1 = require("./UnsupportedMediaTypeException");
const RequestExpiredException_1 = require("./RequestExpiredException");
const SubscriptionRequiredException_1 = require("./SubscriptionRequiredException");
const SentryAccessDeniedException_1 = require("@amzn/coral_com-amazon-sentry-sso/SentryAccessDeniedException");
const SentryInternalServerError_1 = require("@amzn/coral_com-amazon-sentry-sso/SentryInternalServerError");
const SentryRedirectException_1 = require("@amzn/coral_com-amazon-sentry-sso/SentryRedirectException");
const SentryBadRequestException_1 = require("@amzn/coral_com-amazon-sentry-sso/SentryBadRequestException");
const SentryUnauthorizedException_1 = require("@amzn/coral_com-amazon-sentry-sso/SentryUnauthorizedException");
const ValidationException_1 = require("@amzn/coral_com-amazon-coral-validate/ValidationException");
const MessagePublishException_1 = require("@amzn/coral_com-amazon-coral-service-jms/MessagePublishException");
const MessageProcessingException_1 = require("@amzn/coral_com-amazon-coral-service-jms/MessageProcessingException");
const InvalidMessageDigestException_1 = require("@amzn/coral_com-amazon-coral-service-http/InvalidMessageDigestException");
const HeaderMisclassificationException_1 = require("@amzn/coral_com-amazon-coral-service-http/HeaderMisclassificationException");
const InvalidAuthSchemeParameterException_1 = require("@amzn/coral_com-amazon-coral-service-http/InvalidAuthSchemeParameterException");
const MissingRequiredHeaderException_1 = require("@amzn/coral_com-amazon-coral-service-http/MissingRequiredHeaderException");
const MissingAuthSchemeParameterException_1 = require("@amzn/coral_com-amazon-coral-service-http/MissingAuthSchemeParameterException");
const MissingMessageDigestException_1 = require("@amzn/coral_com-amazon-coral-service-http/MissingMessageDigestException");
const HttpNotFoundException_1 = require("@amzn/coral_com-amazon-coral-service-http/HttpNotFoundException");
const InvalidAuthSchemeException_1 = require("@amzn/coral_com-amazon-coral-service-http/InvalidAuthSchemeException");
const ihm_js_coral_client_1 = require("@amzn/ihm-js-coral-client");
const ihm_js_coral_client_2 = require("@amzn/ihm-js-coral-client");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
exports.unknownServiceSerdesInterceptor = new ihm_js_coral_client_2.CoralClientSerdesInterceptor({
    UnknownOperation: {
        modelledExceptions: [],
    },
}, [
    BackOffException_1.BackOffException,
    ThrottlingException_1.ThrottlingException,
    ClientUnavailableException_1.ClientUnavailableException,
    HttpConnectionTimeoutException_1.HttpConnectionTimeoutException,
    HttpFailureException_1.HttpFailureException,
    HttpTimeoutException_1.HttpTimeoutException,
    InvalidCodigoMessageException_1.InvalidCodigoMessageException,
    HeaderMisclassificationException_1.HeaderMisclassificationException,
    HttpNotFoundException_1.HttpNotFoundException,
    InvalidAuthSchemeException_1.InvalidAuthSchemeException,
    InvalidAuthSchemeParameterException_1.InvalidAuthSchemeParameterException,
    InvalidMessageDigestException_1.InvalidMessageDigestException,
    MissingAuthSchemeParameterException_1.MissingAuthSchemeParameterException,
    MissingMessageDigestException_1.MissingMessageDigestException,
    MissingRequiredHeaderException_1.MissingRequiredHeaderException,
    MessageProcessingException_1.MessageProcessingException,
    MessagePublishException_1.MessagePublishException,
    AccessDeniedException_1.AccessDeniedException,
    DelegationException_1.DelegationException,
    ExpiredTokenException_1.ExpiredTokenException,
    IncompleteSignatureException_1.IncompleteSignatureException,
    InternalFailure_1.InternalFailure,
    InvalidAwsQueryStringException_1.InvalidAwsQueryStringException,
    InvalidParameterCombinationException_1.InvalidParameterCombinationException,
    InvalidParameterValueException_1.InvalidParameterValueException,
    InvalidQueryParameterException_1.InvalidQueryParameterException,
    InvalidQueryStringException_1.InvalidQueryStringException,
    InvalidSignatureException_1.InvalidSignatureException,
    MalformedHttpRequestException_1.MalformedHttpRequestException,
    MissingActionException_1.MissingActionException,
    MissingAuthenticationTokenException_1.MissingAuthenticationTokenException,
    MissingRequiredParameterException_1.MissingRequiredParameterException,
    NotAuthorizedException_1.NotAuthorizedException,
    RequestAbortedException_1.RequestAbortedException,
    RequestEntityTooLargeException_1.RequestEntityTooLargeException,
    RequestExpiredException_1.RequestExpiredException,
    RequestTimeoutException_1.RequestTimeoutException,
    SerializationException_1.SerializationException,
    ServiceUnavailableException_1.ServiceUnavailableException,
    SubscriptionRequiredException_1.SubscriptionRequiredException,
    TimeoutException_1.TimeoutException,
    TransmutationException_1.TransmutationException,
    UnknownOperationException_1.UnknownOperationException,
    UnrecognizedClientException_1.UnrecognizedClientException,
    UnsupportedMediaTypeException_1.UnsupportedMediaTypeException,
    ValidationException_1.ValidationException,
    SentryAccessDeniedException_1.SentryAccessDeniedException,
    SentryBadRequestException_1.SentryBadRequestException,
    SentryInternalServerError_1.SentryInternalServerError,
    SentryRedirectException_1.SentryRedirectException,
    SentryUnauthorizedException_1.SentryUnauthorizedException,
]);
class UnknownService extends ihm_js_coral_client_1.CoralClient {
    constructor(config, handler) {
        const serdesHandler = new ihm_js_coral_client_2.InterceptingHandler(handler, [
            exports.unknownServiceSerdesInterceptor,
        ]);
        super(config, serdesHandler);
    }
    unknownOperation() {
        return super.call("UnknownOperation").pipe(operators_1.map(() => undefined), operators_1.catchError((error) => rxjs_1.throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === ihm_js_coral_client_1.CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
}
exports.UnknownService = UnknownService;
UnknownService.assembly = "com.amazon.coral.service";
UnknownService.serviceName = "UnknownService";
